import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroll-component';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import CustomCard from '../../shared/CustomCard';
import EmptyFolder from '../../../assets/EmptyFolder';

const useStyles = makeStyles({
  emptyState: {
    height: '100%',
    minHeight: '200px',
  },
  emptyTitle: {
    fontFamily: 'Lato',
    fontSize: '14px',
    fontWeight: 600,
    color: '#10182B',
    marginTop: '16px',
  },
  emptySubtitle: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 500,
    color: '#667085',
    marginTop: '4px',
  },
});

const DEALERSHIP_FIELD_NAME = 'dealerships';
const CARD_WIDTH = '321px';
const CARD_HEIGHT = '80px';
const LIST_HEIGHT = '38vh';

const isRowSelected = (selectedIds, dealershipId) => {
  if (dealershipId == null || _isEmpty(selectedIds)) return false;
  return _includes(selectedIds, dealershipId) || _includes(selectedIds, String(dealershipId));
};

const DealershipCard = ({ dealership, selectedIds, handleDataChange, selectAllMode, excludedIds }) => {
  const isSelected = selectAllMode
    ? !excludedIds?.has(dealership.id)
    : isRowSelected(selectedIds, dealership.id);
  return (
    <Grid item xs={4}>
      <CustomCard
        id={dealership.id}
        name={DEALERSHIP_FIELD_NAME}
        checkbox
        menu={false}
        title={dealership.name}
        subTitle={`Dealership ID : ${dealership.id}`}
        thirdTitle={`${dealership.employeeCount} Employees`}
        width={CARD_WIDTH}
        height={CARD_HEIGHT}
        status={dealership.enabled}
        selected={isSelected}
        handleChange={handleDataChange}
      />
    </Grid>
  );
};

const DealershipList = ({ filteredDealershipArray, data, handleDataChange, selectAllMode, excludedIds, hasMore, fetchNextPage }) => {
  const classes = useStyles();

  if (_isEmpty(filteredDealershipArray)) {
    return (
      <Grid container direction="column" justifyContent="center" alignItems="center" className={classes.emptyState}>
        <EmptyFolder />
        <Typography className={classes.emptyTitle}>No dealerships found</Typography>
        <Typography className={classes.emptySubtitle}>Try adjusting your search or filters</Typography>
      </Grid>
    );
  }

  const selectedIds = data?.dealerships || [];

  return (
    <InfiniteScroll
      dataLength={filteredDealershipArray.length}
      next={fetchNextPage}
      hasMore={hasMore}
      height={LIST_HEIGHT}
      loader={<h5>Loading...</h5>}
    >
      <Grid container>
        {filteredDealershipArray.map((dealership) => (
          <DealershipCard
            key={dealership.hash ?? dealership.id}
            dealership={dealership}
            selectedIds={selectedIds}
            handleDataChange={handleDataChange}
            selectAllMode={selectAllMode}
            excludedIds={excludedIds}
          />
        ))}
      </Grid>
    </InfiniteScroll>
  );
};

export default React.memo(DealershipList);
